import { gql } from 'graphql-request';

export const CACHE_INVOICE_PAY_INTERNAL_ASYNC_QUERY = gql`
  mutation CacheInvoicePayInternalAsync(
    $uuid: ID!
    $paymentMethod: String!
    $accountId: ID
    $fileAttachmentId: ID
  ) {
    invoicePayInternalAsync(
      input: {
        uuid: $uuid
        paymentMethod: $paymentMethod
        accountId: $accountId
        fileAttachmentId: $fileAttachmentId
      }
    ) {
      appVersion
      errors {
        fullMessages
      }
      record {
        id
        nanoId
        uuid
      }
      recordId
      recordNanoId
      recordUuid
      status
    }
  }
`;
